import React from 'react';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Footer from './components/Footer';
import StickyBookButton from './components/StickyBookButton';

function App() {
  return (
    <div className="min-h-screen flex flex-col font-sans">
      <Navbar />
      <main className="flex-grow">
        <Home />
      </main>
      <Footer />
      <StickyBookButton />
    </div>
  );
}

export default App;